<template>
<div class="OrderList">
    <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="全部" name="0">
            <orderListItem ref="orderList0" @getList="_refresh"></orderListItem>
        </el-tab-pane>
        <el-tab-pane label="待发货" name="1">
            <orderListItem ref="orderList1" @getList="_refresh"></orderListItem>
        </el-tab-pane>
        <el-tab-pane label="待核销" name="2">
            <orderListItem ref="orderList2" @getList="_refresh"></orderListItem>
        </el-tab-pane>
        <el-tab-pane label="已完成" name="3">
            <orderListItem ref="orderList3" @getList="_refresh"></orderListItem>
        </el-tab-pane>
    </el-tabs>
</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import OrderListItem from 'views/brandBusiness/activityMgt/order/components/orderList.vue'
export default {
    name: 'BBOrderList',
    data() {
        return {
            activeName: '0'
        }
    },
    mounted() {
        if (!this.isRefresh) {
            this.$nextTick(() => {
                this.$refs['orderList'+this.activeName].getList(this.activeName)
            })
        }
    },
    activated() {
        if (this.isRefresh) {
            if (this.isRefresh === 2) {
                this.activeName = '0'
                this.$refs['orderList0'].initParam()
                this.$refs['orderList1'].initParam()
                this.$refs['orderList2'].initParam()
                this.$refs['orderList3'].initParam()
                this.$refs['orderList'+this.activeName].getList(this.activeName)
            } else {
                this._refresh()
            }
            this.setIsRefresh(0)
        }
    },
    methods: {
        handleClick() {
            this.$refs['orderList'+this.activeName].getList(this.activeName)
        },
        _refresh() {
            this.$refs['orderList0']._refresh('0')
            this.$refs['orderList1']._refresh('1')
            this.$refs['orderList2']._refresh('2')
            this.$refs['orderList3']._refresh('3')
        },
        ...mapActions([
            'setLoading', 'setIsRefresh'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters(['page', 'user', 'params', 'isRefresh'])
    },
    components: {
        OrderListItem
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.OrderList {
    background: #fff;
    padding: 20px;
}
</style>
